import { ConnectedRouter } from "connected-react-router";
import PropTypes from "prop-types";
import React, { Component, Suspense, lazy } from "react";
import Loader from "react-loader";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { EventType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { MsalContext } from "@azure/msal-react";
import { Switch } from "react-router";
import { Route, BrowserRouter as Router } from "react-router-dom";
import { fileUploadPage } from "../src/actions/BusinessRulesActions";
import {
  getDashboardData,
  getEmployeesData,
  getNotificationMessage,
  getRequestType,
  getUserDetails,
  getUserImage,
  isValidApprover,
  isValidToken,
  setProgressBar,
  setSessionExpired,
  setSuperAdminFlag,
  statusSeasonList,
} from "./actions/PTOActions";
import { loginRequest, msalInstanceConfig } from "./authentication/authConfig";
import ErrorBoundaryComponent from "./components/ErrorHandle/errorBoundary";
import SessionTimeout from "./components/SessionTimeOut/SessionTimeOut";
import SvgSpritemap from "./components/SvgSpritemap";
import { init_locale } from "./init-locale";
import ptoTrackerService from "./services/ptoTracker.service";
import TelemetryProvider from "./telemetry-provider";
import { getAppInsights } from "./TelemetryServices.js";
import { getGuid } from "./utils/guid";

import Footer from "../src/layout/Footer/footer.js";
import ProjectHeader from "../src/layout/Header/ProjectHeader";
const RequestAndApprove = lazy(() => import("../src/pages/PTO/Employee"));
const Approver = lazy(() => import("../src/pages/PTO/Approver"));
const RequestAndApprover = lazy(() =>
  import("../src/pages/PTO/RequestAndApprover")
);
const BusinessGrid = lazy(() =>
  import("../src/pages/BusinessRules/BusinessGrid")
);
const BusinessRuleDetails = lazy(() =>
  import("../src/pages/BusinessRules/BusinessRuleDetails")
);
const Reports = lazy(() => import("../src/pages/Reports/Reports"));
const FileUploadPage = lazy(() =>
  import("../src/pages/FileUpload/FileUploadPage")
);
const UserAccess = lazy(() => import("../src/pages/UserAccess/UserAccess"));
const Calender = lazy(() => import("../src/pages/Calender/Calender"));
const AvailabilitySurvey = lazy(() =>
  import("../src/pages/Survey/AvailabilitySurveyPage")
);
const AdminPage = lazy(() => import("../src/pages/AdminModule/AdminPage"));

const Error = lazy(() => import("../src/pages/AccessDenied/Errorpage"));
const ManageTemplates = lazy(() =>
  import("../src/pages/ManageTemplates/ManageTemplatesPage")
);

const WorkFromHome = lazy(() =>
  import("../src/pages/PTO/WfhRequestAndApprover")
);
const SuperAdmin = lazy(() => import("../src/pages/SuperAdmin/SuperAdmin"));

// eslint-disable-next-line no-unused-vars
let appInsights = null;

const mapStateToProps = (state) => ({
  isSessionExpired: state.pto.sessionExpired,
  userDetails: state.pto.getUserDetails,
  isLoading: state.pto.isLoading,
  fileUploadPage: state.businessRules.fileUploadPage,
  isToken: state.pto.isValidToken,
});

const mapDispatchToProps = (dispatch) => ({
  setSessionExpired: (isSessionExpired) =>
    dispatch(setSessionExpired(isSessionExpired)),
  getUserDetails: (userDetails) => dispatch(getUserDetails(userDetails)),
  isValidApprover: (flag) => dispatch(isValidApprover(flag)),
  fileUploadPage: (flag) => dispatch(fileUploadPage(flag)),
  isValidToken: (flag) => dispatch(isValidToken(flag)),
  setProgressBar: (flag) => dispatch(setProgressBar(flag)),
  statusSeasonList: (payload) => dispatch(statusSeasonList(payload)),
  setSuperAdminFlag: (flag) => dispatch(setSuperAdminFlag(flag)),
  getNotificationMessage: (payload) =>
    dispatch(getNotificationMessage(payload)),
  getDashboardData: (payload) => dispatch(getDashboardData(payload)),
  getUserImage: (payload) => dispatch(getUserImage(payload)),
  getRequestType: (requestType) => dispatch(getRequestType(requestType)),
  getEmployeesData: (employeesData) =>
    dispatch(getEmployeesData(employeesData)),
});

let idleTimeOutFlag = false;
let componentRenderer = false;

const loadOptions = {
  lines: 13,
  length: 20,
  width: 10,
  radius: 30,
  scale: 1.0,
  corners: 1,
  color: "#86BC25",
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  top: "50%",
  left: "50%",
  shadow: false,
  hwaccel: false,
  position: "absolute",
};

class App extends Component {
  static contextType = MsalContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowSessionWindow: false,
      isModal: false,
      isLogin: false,
      isLoading: false,
      isSuperAdminFlag: "",
    };
    this.idleTimer = null;
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.getUserDetails = this.getUserDetails.bind(this);
    this.toggleAccessBox = this.toggleAccessBox.bind(this);
    this.callLogin = this.callLogin.bind(this);
    this.handleAccessDenied = this.handleAccessDenied.bind(this);
    this.assignDataToPropsAndState = this.assignDataToPropsAndState.bind(this);
    //store the previous pathName and search strings
    this.currentPathname = null;
    this.currentSearch = null;
  }

  _onActive() {
    if (!idleTimeOutFlag) {
      this.setState({
        //isShowSessionWindow: false,
      });
    }
  }

  _onIdle() {
    if (!this.state.isShowSessionWindow) {
      this.props.setSessionExpired(true);
      idleTimeOutFlag = false;
      setTimeout(() => {
        if (this.state.isShowSessionWindow) {
          this.props.setSessionExpired(false);
        }
      }, 12000);
    }
  }

  toggleAccessBox() {
    this.setState({ isModal: false });
  }

  async componentDidMount() {
    init_locale();
    this.setState({ isLoading: true });
    componentRenderer = true;
    if (this.state.isLogin === false) {
      this.callLogin();
    }
    const { history } = this.props;
    history.listen((newLocation, action) => {
      if (action === "PUSH") {
        if (
          newLocation.pathname !== this.currentPathname ||
          newLocation.search !== this.currentSearch
        ) {
          this.currentPathname = newLocation.pathname;
          this.currentSearch = newLocation.search;
          history.push({
            pathname: newLocation.pathname,
            search: newLocation.search,
          });
        }
      }
    });
  }

  async callLogin() {
    const isAuthenticated = this.context.accounts.length > 0;
    const msalInstance = this.context.instance;

    if (!isAuthenticated) {
      this.setState({ isLogin: true });
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }

      msalInstance.addEventCallback((event) => {
        // Set active account after redirect
        if (
          event.eventType === EventType.LOGIN_SUCCESS &&
          event.payload.account
        ) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
        }
      });

      // Handle auth redirect and do all initial setup for msal
      msalInstance
        .handleRedirectPromise()
        .then(() => {
          // Check if user signed in
          const account = msalInstance.getActiveAccount();
          if (!account) {
            // Redirect anonymous user to login page
            msalInstance.loginRedirect(loginRequest).catch((error) => {
              if (error instanceof InteractionRequiredAuthError) {
                // Handle MFA requirement
                msalInstance.acquireTokenRedirect(loginRequest);
              } else {
                console.error("Token Failed");
              }
            });
          }
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            // Handle MFA requirement
            msalInstance.acquireTokenRedirect(loginRequest);
          } else {
            console.error("Token Failed");
          }
        });
    }
  }

  async getUserDetails() {
    try {
      const email = this.context?.accounts?.[0]?.username;
      const payload = {
        traceId: getGuid(),
        email,
      };

      const userDetails = await ptoTrackerService.getUserDetails(payload);

      this.props.getUserDetails(userDetails);

      if (userDetails.user === null) {
        this.handleAccessDenied();
      }
      this.getDashboardDetails();
    } catch (error) {
      this.setState({ isLoading: false });
      console.error(error);
    }
  }

  async getSuperAdminViewCheckForAutoApprovalAdmin() {
    try {
      const email = this.context?.accounts?.[0]?.username;
      const payload = {
        traceId: getGuid(),
        email,
      };

      const superAdmin =
        await ptoTrackerService.getSuperAdminViewCheckForAutoApprovalAdmin(
          payload
        );

      this.props.setSuperAdminFlag(superAdmin?.isActive);
      this.setState({ isSuperAdminFlag: superAdmin?.isActive });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleAccessDenied() {
    this.props.history.push("/access-denied");
    this.setState({ showLoader: false });
  }

  async getDashboardDetails() {
    const payload = {
      traceId: getGuid(),
      email: this.context?.accounts[0]?.username,
    };
    try {
      const dashboardDetails = await ptoTrackerService.getDashboardDetails(
        payload
      );
      this.props.getDashboardData(dashboardDetails);
      this.assignDataToPropsAndState(dashboardDetails);

      this.getSuperAdminViewCheckForAutoApprovalAdmin();
    } catch (error) {
      console.error(error);
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.isSessionExpired && !prevProps.isSessionExpired) {
      this.props.setSessionExpired(false);
      this.setState({
        isShowSessionWindow: true,
      });
    }
    if (componentRenderer === true && this.context.accounts.length > 0) {
      if (this.props.userDetails.length === 0) {
        if (
          this.props.location.pathname !== "/" &&
          this.props.location.state !== "reload"
        ) {
          this.props.fileUploadPage(true);
        } else {
          this.props.history.push({
            pathname: this.props.location.pathname,
            state: "",
          });
        }
        componentRenderer = false;
        this.props.isValidToken(false);
        await this.getUserDetails();
      }
    } else {
      if (prevProps.fileUploadPage !== this.props.fileUploadPage) {
        await this.getUserDetails();
      }
    }
  }

  assignDataToPropsAndState = (data) => {
    this.props.isValidApprover(data?.validApprover);
    this.props.statusSeasonList(data?.reportDropDownData);
    this.props.getNotificationMessage(data?.activeNotificationMessage);
    this.props.getRequestType(data?.flexibilityTypes);
    this.props.getEmployeesData(data?.userFlexibilitiesList);
    // For User Image
    const base64String = data?.getPhotoAsByteArray;
    const img = new Image();
    img.src = `data:image/jpeg;base64,${base64String}`;
    this.props.getUserImage(img.src);
  };

  render() {
    return (
      <React.Fragment>
        <ConnectedRouter history={this.props.history}>
          <SvgSpritemap />
          {this.state.isSuperAdminFlag !== "" && (
            <div style={{ height: "100vh" }}>
              <Router>
                <TelemetryProvider
                  instrumentationKey={
                    window?.environment?.REACT_APP_APP_INSIGHTS
                  }
                  after={() => {
                    appInsights = getAppInsights();
                  }}
                >
                  <Switch>
                    <Suspense
                      fallback={
                        <Loader options={loadOptions} className="spinner" />
                      }
                    >
                      {window.location.pathname !== "/access-denied" && (
                        <ProjectHeader />
                      )}
                      <Route
                        exact={true}
                        path="/"
                        component={
                          window.location.pathname !== "/access-denied"
                            ? RequestAndApprove
                            : Error
                        }
                      ></Route>
                      <Route path="/approver" component={Approver}></Route>
                      <Route path="/pto" component={RequestAndApprover}></Route>
                      <Route path="/wfh" component={WorkFromHome}></Route>
                      <Route
                        path="/business-rules"
                        component={BusinessGrid}
                      ></Route>
                      <Route
                        path="/business-rules-details"
                        component={BusinessRuleDetails}
                      ></Route>
                      <Route path="/reports" component={Reports}></Route>
                      <Route
                        path="/upload-headcount"
                        component={FileUploadPage}
                      ></Route>
                      <Route path="/userAccess" component={UserAccess}></Route>
                      <Route path="/calender" component={Calender}></Route>
                      <Route path="/admin" component={AdminPage}></Route>
                      <Route
                        path="/survey"
                        component={AvailabilitySurvey}
                      ></Route>
                      <Route
                        path="/manageTemplates"
                        component={ManageTemplates}
                      ></Route>
                      <Route path="/superAdmin" component={SuperAdmin}></Route>
                      <Route path="/access-denied" component={Error}></Route>
                      {window.location.pathname !== "/access-denied" && (
                        <Footer />
                      )}
                    </Suspense>
                  </Switch>
                </TelemetryProvider>
              </Router>
            </div>
          )}

          <SessionTimeout msalInstance={msalInstanceConfig} />

          <Loader
            loaded={!this.state.isLoading}
            options={loadOptions}
            className="spinner loader"
          />
        </ConnectedRouter>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  fileUploadPage: PropTypes.func,
  getUserDetails: PropTypes.func,
  setSuperAdminFlag: PropTypes.func,
  getNotificationMessage: PropTypes.func,
  getDashboardData: PropTypes.func,
  getUserImage: PropTypes.func,
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  }),
  isSessionExpired: PropTypes.any,
  isValidApprover: PropTypes.func,
  isValidToken: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.string,
  }),
  setSessionExpired: PropTypes.func,
  statusSeasonList: PropTypes.func,
  userDetails: PropTypes.shape({
    length: PropTypes.number,
  }),
  getRequestType: PropTypes.func,
  getEmployeesData: PropTypes.func, // Added missing prop validation
};

const ConnectedComponentApp = connect(mapStateToProps, mapDispatchToProps)(App);
const ErrorHandledComponentApp = (props) => {
  return (
    <ErrorBoundaryComponent>
      <ConnectedComponentApp {...props} />
    </ErrorBoundaryComponent>
  );
};
export default withRouter(ErrorHandledComponentApp);
